<template>
  <div class="base-menu-popup menu-popup">
    <div class="base-menu-popup__inner menu-popup__inner">
      <slot name="header" />
      <div
        v-if="$slots.list"
        class="base-menu-popup__bottom"
      >
        <ul class="base-menu-popup__list">
          <slot name="list" />
        </ul>
      </div>
    </div>
    <slot name="addition" />
  </div>
</template>

<style scoped lang="scss">
.base-menu-popup {
  --popup-menu-inner-width: 280px;

  display: none;
  left: var(--gnb-menu-width) !important;
  transition: left $animate-gnb;

  &.shown {
    display: block !important;
  }

  &.shown.expanded {
    left: var(--gnb-menu-width-expanded) !important;
  }

  &:not(.expanded):hover {
    display: block !important;
  }

  &__inner {
    width: var(--popup-menu-inner-width);
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 0 6px;
    border: 1px solid var(--color-gray-05-03);
    border-top: none;
    border-radius: 0 0 4px 4px;
    background-color: var(--color-gray-06-00);
  }
}
</style>
